import { render } from "./GroupAppIcon.vue?vue&type=template&id=ef0427b0&scoped=true"
import script from "./GroupAppIcon.vue?vue&type=script&lang=js"
export * from "./GroupAppIcon.vue?vue&type=script&lang=js"

import "./GroupAppIcon.vue?vue&type=style&index=0&id=ef0427b0&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef0427b0"]])

export default __exports__